export default __webpack_public_path__ + "static/media/preserve.3f99813a.svg";